import { render, staticRenderFns } from "./user-list.vue?vue&type=template&id=21c44dcf&scoped=true&"
import script from "./user-list.vue?vue&type=script&lang=js&"
export * from "./user-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c44dcf",
  null
  
)

export default component.exports